import { z } from "zod"

export const ShopifyIDSchema = z.string()
export type ShopifyID = z.infer<typeof ShopifyIDSchema>

export const ShopifyDateTimeSchema = z.string()
export type ShopifyDateTime = z.infer<typeof ShopifyDateTimeSchema>

export const ShopifyDecimalSchema = z.string()
export type ShopifyDecimal = z.infer<typeof ShopifyDecimalSchema>

export const ShopifyURLSchema = z.string()
export type ShopifyURL = z.infer<typeof ShopifyURLSchema>

// GraphQL Admin exposes CurrencyCode as an enum; keep string here to avoid
// enumerating all ISO and legacy codes while staying validation-friendly.
export const CurrencyCodeSchema = z.string()
export type CurrencyCode = z.infer<typeof CurrencyCodeSchema>

export const WeightUnitSchema = z.enum(["KILOGRAMS", "GRAMS", "POUNDS", "OUNCES"])
export type WeightUnit = z.infer<typeof WeightUnitSchema>

export const FulfillmentServiceTypeSchema = z.enum(["MANUAL", "THIRD_PARTY", "GIFT_CARD"])
export type FulfillmentServiceType = z.infer<typeof FulfillmentServiceTypeSchema>

export const InventoryPolicySchema = z.enum(["DENY", "CONTINUE"])
export type InventoryPolicy = z.infer<typeof InventoryPolicySchema>

// 2026-01 ProductStatus includes UNLISTED (added 2025-10)
export const ProductStatusSchema = z.enum(["ACTIVE", "ARCHIVED", "DRAFT", "UNLISTED"])
export type ProductStatus = z.infer<typeof ProductStatusSchema>

export const UnitPriceMeasurementMeasuredUnitSchema = z.enum([
  "ML",
  "CL",
  "L",
  "M3",
  "MG",
  "G",
  "KG",
  "MM",
  "CM",
  "M",
  "M2",
])
export type UnitPriceMeasurementMeasuredUnit = z.infer<typeof UnitPriceMeasurementMeasuredUnitSchema>